import { render, staticRenderFns } from "./PlayerExerciseHistoryDialogRow.vue?vue&type=template&id=86c56488&scoped=true"
import script from "./PlayerExerciseHistoryDialogRow.vue?vue&type=script&lang=js"
export * from "./PlayerExerciseHistoryDialogRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c56488",
  null
  
)

export default component.exports